var _path, _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04675 4.8853C7.05277 4.39462 7.45226 4 7.94298 4C8.44228 4 8.84533 4.40802 8.8392 4.90728L8.80358 7.81141C8.79756 8.30209 8.39807 8.69671 7.90735 8.69671C7.40805 8.69671 7.00501 8.28869 7.01113 7.78942L7.04675 4.8853Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9.59308,
    width: 1.79272,
    height: 1.79272,
    rx: 0.896359,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteClockIcon);
export default __webpack_public_path__ + "static/media/white-clock-icon.c615dbc6c13c975b105f9bfdd12a8b95.svg";
export { ForwardRef as ReactComponent };